import defaultLogo from '../assets/app-logo.png'

export const DEFAULT_LOGO_URL: string = defaultLogo

interface BrandBadgeProps {
  size: number
  logoUrl: string | null
  appName: string
}

export default function BrandBadge({ size, logoUrl, appName }: BrandBadgeProps) {
  if (logoUrl && logoUrl !== DEFAULT_LOGO_URL) {
    return (
      <img
        src={logoUrl}
        alt={appName}
        style={{ width: size, height: size, objectFit: 'contain' }}
      />
    )
  }
  // Large badges need breathing room so the artwork never touches the ring;
  // small ones give the logo more of the circle so it stays legible.
  const large = size >= 64
  const logoScale = large ? '66%' : '80%'
  const ring = large ? 2 : 1
  return (
    <div
      className="flex items-center justify-center shrink-0 overflow-hidden rounded-full"
      style={{
        width: size,
        height: size,
        background: '#ffffff',
        border: `${ring}px solid var(--border-default)`,
      }}
    >
      <img
        src={DEFAULT_LOGO_URL}
        alt={appName}
        style={{ width: logoScale, height: logoScale, objectFit: 'contain' }}
      />
    </div>
  )
}
